/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.248 8.489L6.248 10.792 8.52 9.686 8.52 7.384zM2.839 9.127L5.679 10.791 5.679 8.48 2.839 6.815zM3.781 5.679L2.839 6.092 5.978 7.951 6.815 7.435zM7.952 6.867L4.918 5.112 3.977 5.525 7.115 7.384z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.679 14.283c-.435 0-.787-.346-.787-.773 0-.427.352-.773.787-.773.434 0 .786.346.786.773 0 .427-.352.773-.786.773zm4.032-1.835H1.65V4.321c-.049.005-.098.008-.148.008-.357 0-.683-.133-.934-.352v9.825c0 .533.44.966.983.966h8.258c.543 0 .983-.433.983-.966V3.977c-.251.219-.577.352-.934.352-.05 0-.099-.003-.147-.008v8.127zM5.68 2.272h5.511c.306-.198.102-.494.102-.494L10.068 0H1.291L.067 1.778s-.204.296.102.494H5.68z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.519.85H0c.095.607.701 1.075 1.437 1.075.687 0 1.261-.409 1.411-.957.151.548.725.957 1.412.957.687 0 1.261-.409 1.411-.957.15.548.724.957 1.411.957s1.261-.409 1.411-.957c.151.548.725.957 1.412.957.735 0 1.342-.468 1.437-1.075H8.519z",
  mask: "url(#prefix__b)"
}))), 'PickupStore', {
  viewBox: '0 0 18 14'
});